import styled from "styled-components";

const ContentWrapper = styled.div`
	width: 100%;
	height: fit-content;
`;

export default ContentWrapper;
